export default {
  // This component doesn't have static translatable strings
  // Uses dynamic data passed from props (title)
}
